//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import theme from './TeamChip.scss';
import classnames from 'classnames';
import Chip from 'common/components/core/common/Chip';

type Props = {
    invert?: boolean,
    label?: string,
    teamName?: string,
    teamColor?: string,
    className: ?string,
    theme: Object,
    team?: { name: string, teamId: string, color: string },
    noTeamText?: string,
    showNoTeam?: boolean,
    style?: Object,
    backgroundColor?: string,
    rightIcon?: string,
    rightIconProps?: Object,
    id?: string,
    showOverflowTooltip?: boolean,
    onContextMenu?: (e: Event, id?: string) => void,
    onClick?: (e: Event, id?: string) => void,
    testId?: string,
    disabled?: boolean
};

/**
    @Deprecated : You can use the new TeamChip component instead, as it's consuming neo-ui. Name - TeamChipNeo
*/
class TeamChip extends React.PureComponent<Props> {
    static defaultProps = {
        invert: true,
        showNoTeam: true
    };
    onContextMenu = e => {
        const { onContextMenu, id } = this.props;
        onContextMenu?.(e, id);
    };
    onClick = e => {
        const { onClick, id } = this.props;
        onClick?.(e, id);
    };
    render() {
        const {
            team,
            label,
            theme,
            teamName,
            teamColor,
            className,
            invert,
            noTeamText,
            showNoTeam,
            style,
            showOverflowTooltip,
            rightIcon,
            rightIconProps,
            backgroundColor,
            testId,
            disabled
        } = this.props;
        let displayName;
        let borderColor;
        if (team) {
            const { name, teamId, color } = team;
            displayName = name ? name : teamId;
            borderColor = color;
        } else {
            displayName = teamName;
            borderColor = teamColor;
        }
        if (!displayName) {
            return null;
        }
        return (
            <Chip
                testId={testId}
                showOverflowTooltip={showOverflowTooltip}
                onContextMenu={this.onContextMenu}
                onClick={this.onClick}
                className={classnames(className, theme.teamChipWrap)}
                label={label}
                emptyText={noTeamText}
                showEmptyText={showNoTeam}
                text={displayName}
                leftBorderColor={borderColor}
                invert={invert}
                theme={theme}
                backgroundColor={backgroundColor}
                style={style}
                rightIcon={rightIcon}
                rightIconProps={rightIconProps}
                disabled={disabled}
            />
        );
    }
}
const ThemedTeamChip = themr('TeamChip', theme)(TeamChip);

export { TeamChip as UnthemedTeamChip };
export default ThemedTeamChip;
